import type { NotificationsViewProviderProps } from "./notifications-view.type";

import { NotificationsViewContext } from "./notifications-view.context";
import { useNotificationsViewProvider } from "./notifications-view.hook";

export const NotificationsViewProvider = ({
  view,
  children,
}: NotificationsViewProviderProps) => {
  const data = useNotificationsViewProvider(view);

  return (
    <NotificationsViewContext.Provider value={data}>
      {children}
    </NotificationsViewContext.Provider>
  );
};
